<template>
  <div class="channel-wrapper">

    <Head :lanshow="ActiveName" :title="$tc('header.back')" />
    <!-- <NavBar /> -->

    <div class="channel-inner">
      <h5 class="mianbaoxie">
        <span> 当前地址：</span><span> 首页 </span>
        <span v-if="channelData && channelData.channel && channelData.channel.name">
          > {{ channelData.channel.name }}
        </span>
        <!-- <span v-if="$route.query.id == 128"> > {{ $route.query.name }}</span> -->
        <span v-if="emptydata"> > {{ $route.query.name }}</span>
      </h5>
      <div class="title">
        <div class="text" v-if="channelData && channelData.channel && channelData.channel.name">
          {{ channelData.channel.name }}
        </div>
        <div class="text" v-else-if="$route.query.name">
          {{ $route.query.name }}
        </div>
        <div class="line" />
      </div>
      <Empty :emptydata="emptydata" v-if="emptydata" />
      <!-- 数据 -->
      <van-list v-model="loading" id="van-list-content" finished-text="" :finished="finished" @load="onLoad">
        <!-- <van-cell v-for="item in channelData && channelData.list"
                  :key="item.itemId"
                  @click="toDetail(item.itemId)">
          <div>
            <p class="span1">
              {{ item.itemTitle }}
            </p>
          </div>
          <span class="span2">{{ filterData(item.itemPublishTime) }}</span>
        </van-cell> -->
        <van-cell v-for="(item,index) in list" :key="index" @click="toDetail(item.itemId,item)" v-show="item.flag != 1">
          <div>
            <p class="span1">
              {{ item.itemTitle }}
            </p>
          </div>
          <span class="span2">{{ filterData(item.itemPublishTime) }}</span>
        </van-cell>
      </van-list>

    </div>
    <Footer />
  </div>
</template>

<script>
import Banner from '@/components/Channel/Banner.vue'
import NewsList from '@/components/Channel/NewsList.vue'
import Moment from 'moment'

import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Channel',
  data () {
    return {
      listTotal: 20,
      homeInfoMenuList: [],
      channel_list: [],
      list: [],
      loading: false,
      finished: false,
      id: '',
      channelData: null,
      subjectList: [],
      subjectCurIndex: 0,
      showAll: false,
      pageSize: 0,
      emptydata: null,
      channelId: 15 // 频道id
    }
  },
  computed: {
    ...mapState(['lang', 'timer', 'ActiveName'])
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Banner,
    // eslint-disable-next-line vue/no-unused-components
    NewsList
  },
  created () {
    this.id = parseInt(this.$route.params.id)
    this.onLoad()
    // 用户是否登录
    // const token =
    //   localStorage.getItem('userInfo') &&
    //   JSON.parse(localStorage.getItem('userInfo')) &&
    //   JSON.parse(localStorage.getItem('userInfo')).token
    // if (token) {
    //   // 显示登陆头像
    //   this.setActiveName(true)
    // } else {
    //   this.setActiveName(false)
    // }
  },
  mounted () {
    this.getChannelData()
    this.$nextTick(() => {
      this.$Common.pageShare()
    })
  },
  watch: {
    $route () {
      this.id = parseInt(this.$route.params.id)
      this.getChannelData()
      this.onLoad()
      // 用户是否登录
      const token =
        localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo')) &&
        JSON.parse(localStorage.getItem('userInfo')).token
      if (token) {
        // 显示登陆头像
        this.setActiveName(true)
      } else {
        this.setActiveName(false)
      }
    }
  },

  methods: {
    ...mapMutations(['setShowLoading', 'setTimer', 'setActiveName']),
    filterData (time) {
      return Moment(time).format('YYYY-MM-DD')
    },
    onLoad () {
      // 如果当前的list数组长度 大于等于请求回来的总长度时，让list数组 = 请求回来的数组的总长度
      if (this.list.length >= this.listTotal) {
        this.list = this.list.splice(0, this.listTotal)// 让总的数据的那个数组覆盖list数组
        this.pageSize = this.listTotal
        return
      }
      this.pageSize = (this.pageSize + 20) / 1
      if (this.list.length > 0) {
        this.getChannelData()
      }
    },
    getChannelData () {
      if (this.$route.query && this.$route.query.channelId) {
        this.channelId = this.$route.query.channelId
      } else {
        this.channelId = this.id
      }
      this.$Api
        .getChannelList({
          channelId: this.channelId,
          pageSize: this.pageSize
        })
        .then((data) => {
          if (!data) {
            this.emptydata = {
              type: 'nodata'
            }
            this.channelData = null
            this.loading = false
            this.finished = true
            this.list = []
          } else {
            this.channelData = data
            // this.list = [...data.list]
            this.list = data && data.list
            this.listTotal = data.listTotal // 总的数据条数
            this.$Common.track('load', {
              name: data.channel && data.channel.name,
              id: this.id,
              type: '资讯'
            })
            this.emptydata = null
          }
          this.setShowLoading(false)
          // 加载状态结束
          this.loading = false
          if (this.list.length == data.listTotal) {
            this.finished = true
          }
        })
        .catch(() => {
          this.emptydata = {
            type: 'nonetwork'
          }
          this.setShowLoading(false)
        })
    },
    changeSubject (index) {
      this.subjectCurIndex = index
    },
    toggleSubject () {
      this.showAll = !this.showAll
    },
    toDetail (id, item) {
      if (item.itemExternalUrl && this.$Common.isHyperlinks(item.itemExternalUrl)) {
        window.location.href = item.itemExternalUrl
      } else {
        let names =
          this.channelData &&
          this.channelData.channel &&
          this.channelData.channel.name
        if (!names) {
          names = this.$route.query.name
        }
        this.$router.push({
          path: `/news/${id}`,
          query: {
            id,
            name: names
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.channel-wrapper {
  // height: 100%;
  .channel-inner {
    // height: 100%;
    min-height: 68vh;
    .channel-latest-wrapper {
      width: 100%;
    }
  }
}
.span1 {
  overflow: hidden; //将超出的部分隐藏
  text-overflow: ellipsis; //超出部分用省略号显示
  display: -webkit-box; //将对象作为弹性伸缩盒子模型显示
  -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
  -webkit-line-clamp: 2; //这个属性不是css的规范属性，需要组合上面的两个属性，2表示显示的行数(我这里仅写2，可以是任何数字)
  font-size: 4.26vw;
  font-family: MicrosoftYaHei;
  color: #000000;
}
.span2 {
  font-size: 3.2vw;
  font-family: MicrosoftYaHei;
  color: #666666;
}
.title {
  margin-top: 5.33vw;
}
// .van-list {
//   min-height: 56.2%;
// }
</style>
